export const usertypeList = [ 1, 2, 3 ];

export const MEETHOUR_USER = 'MEETHOUR_USER';

export const REGISTERED_USER = 'REGISTERED_USER';

export const GUEST_USER = 'GUEST_USER';

export const userType = {
    [usertypeList[0]]: MEETHOUR_USER,
    [usertypeList[1]]: REGISTERED_USER,
    [usertypeList[2]]: GUEST_USER

};
